import { render, staticRenderFns } from "./CultureContent.vue?vue&type=template&id=7d9a044c&scoped=true"
import script from "./CultureContent.vue?vue&type=script&lang=ts"
export * from "./CultureContent.vue?vue&type=script&lang=ts"
import style0 from "./CultureContent.vue?vue&type=style&index=0&id=7d9a044c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9a044c",
  null
  
)

export default component.exports